import { clearChangeDistanceRequest } from '../utils';

import { changeDistanceStore } from '../stores';

export function cancelChangeDistance() {
  clearChangeDistanceRequest();
  changeDistanceStore.clean();
}
